module.exports = new __parcel__URL__("suggestions.tpl.dbb32053.svg").toString();